function init(elementId, chartModel, chartType, position) {

    Chart.defaults.font.size = 11.5;
    Chart.defaults.font.family = "'proxima-nova', sans-serif";
    Chart.defaults.font.weight = 900;

    if (chartModel.options) {

        if (chartModel.options.scales && chartModel.options.scales.y) {
            if (chartType == 'percent') {
                chartModel.options.scales.y.ticks = {
                    callback: function (value, index, ticks) {
                        return value + '%';
                    }
                };
                chartModel.options.plugins = {
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const label = context.raw + '%';
                                return label;
                            }
                        }
                    }
                };
            }
        }
        if (position == 'none') {
            if (chartModel.options.plugins) {

                chartModel.options.plugins.legend = {
                    display: false,
                    position: position
                };


            } else {
                chartModel.options.plugins = {
                    legend: {
                        display: false,
                        position: position
                    }
                };
            }

        } else {

            if (chartModel.options.plugins) {

                chartModel.options.plugins.legend = {
                    display: true,
                    position: position
                };


            } else {
                chartModel.options.plugins = {
                    legend: {
                        display: true,
                        position: position
                    }
                };
            }
        }
    }

    new Chart(document.getElementById(elementId), chartModel);

}

export default {
    init
}